module.exports = __webpack_public_path__ + "static/media/89a5687599f173f2b910aa5fcd862b42.89a56875.svg";